interface HttpClientHeaders {
  flow: string;
  command: string;
  cliVersion: string;
}

export const buildHttpClientHeaders = ({
  flow,
  command,
  cliVersion,
}: HttpClientHeaders) => {
  const buildWixBiGatewayHeader = (
    flow: string,
    command: string,
    cliVersion: string
  ) =>
    [
      `environment=CLI-${flow}`,
      `package-version=${cliVersion}`,
      `package-name=${command}`,
    ].join(',');

  return {
    'x-wix-bi-gateway': buildWixBiGatewayHeader(flow, command, cliVersion),
  };
};
